module.exports = __webpack_public_path__ + "img/loading.26ef8bb4.gif";